import configClubRunUpForme from './config-club-runupforme'

const config = {
  ...configClubRunUpForme,
  photo: {
    ...configClubRunUpForme.photo,
    step: "Contact",
  },
  header: {
    ...configClubRunUpForme.header,
    urlLogo: null
  },
  navigation: {
		reinitAuto: true,
		reinitAutoSecs: 300,
		allowChangeClub: false,
	},
}

export default config;
